import { usePostApiV1AccountsFinishCreatingMutation } from '../../../authApi'
import { UpdateUsernameView } from './UpdateUsernameView'
import { useCallback } from 'react'
import { useParams } from 'react-router-dom'
import { getErrorMsg } from '@wellesley/error-kit'
import { useRedirectAfterAuth } from '../../../hooks/useAuthRedirect'

export const UpdateUsername = () => {
  const [finishCreating, { isLoading, isError, error }] =
    usePostApiV1AccountsFinishCreatingMutation()
  const { hash } = useParams<{ hash?: string }>()

  const handleSave = useCallback(
    (username: string) => {
      if (!hash) return
      void finishCreating({
        finishCreatingAccountParams: { username, hash },
      })
    },
    [finishCreating, hash],
  )

  useRedirectAfterAuth()

  return (
    <UpdateUsernameView
      isLoading={isLoading}
      onSave={handleSave}
      error={isError ? getErrorMsg(error) : undefined}
    />
  )
}
